var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.navitem.submenu)?_c('KTMenuItemText',{attrs:{"navitem":_vm.navitem}}):(_vm._.size(_vm.navitem.submenu) > 0)?_c('KTMenuSubmenu',{attrs:{"submenu":_vm.navitem.submenu,"parentMenu":_vm.navitem}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }